import type { ClientRequestOptions } from "hono/client";

export type RpcFetch = NonNullable<ClientRequestOptions["fetch"]>;

/** Deployment bases are configuration; route names/parameters come from Hono's inferred types. */
export function validateApiBase(base: string): string {
  if (!base || /[?#\\]/.test(base))
    throw new Error("The API base must not include a query, fragment or backslash.");
  if (base.startsWith("/") && !base.startsWith("//")) return base.replace(/\/+$/, "") || "/";
  const url = new URL(base);
  if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) {
    throw new Error("The API base must be an HTTP(S) URL without credentials.");
  }
  return url.toString().replace(/\/+$/, "");
}
